
<form class="pb-calculator pb-py-9 pb-px-4 pb-flex pb-flex-col pb-gap-6 lg:pb-px-8">
  <h2 *ngIf="rendering.fields?.Title.value" data-title="true" class="pb-text-color-brand pb-font-serif pb-text-center pb-text-d-md-m lg:pb-text-d-md">{{rendering.fields?.Title?.value}}</h2>
  <div class="pb-flex pb-flex-col pb-gap-5">
    <div
      app-form-range
      [labelText]="rendering?.fields?.FirstInputLabel?.value"
      [name]="'sth'"
      [valueDescription]="'€'"
      [calculatorType]="'mini'"
      [color]="'yellow'"
      [minValue]=rendering?.fields?.FirstInputMin?.value
      [maxValue]=rendering?.fields?.FirstInputMax?.value
      [step]="100"
      (valueChange)="onInputChange($event , 'value')">
    </div>
    <div
      app-form-range
      [labelText]="rendering?.fields?.SecondInputLabel?.value"
      [valueDescription]="'months' | translate"
      [name]="'sth'"
      [calculatorType]="'mini'"
      [color]="'yellow'"
      [minValue]=rendering?.fields?.SecondInputMin?.value
      [maxValue]=rendering?.fields?.SecondInputMax?.value
      [step]="1"
      (valueChange)="onInputChange($event , 'months')">
    </div>
    <div
      app-form-range
      [labelText]="rendering?.fields?.ThirdInputLabel?.value"
      [name]="'sth'"
      [valueDescription]="'€'"
      [calculatorType]="'mini'"
      [color]="'yellow'"
      [minValue]="rendering?.fields?.FirstInputMin?.value / rendering?.fields?.SecondInputMax?.value"
      [maxValue]="rendering?.fields?.FirstInputMax?.value / rendering?.fields?.SecondInputMin?.value"
      [defaultValue]=monthlyPayment
      [isDisabled]=true
      [step]="1"
      (valueChange)="onInputChange($event , 'textValue3')">
    </div>
    
  </div>
  <div class="pb-text-xs-m lg:pb-text-xs pb-article pb-article-piraeus" [innerHTML]="rendering?.fields?.Disclaimer?.value | TrustHtml"></div>
  <div class="pb-flex pb-flex-col pb-gap-2 lg:pb-gap-5">
      <a *ngIf="rendering.fields?.FirstButton?.value?.href" href="{{rendering.fields?.FirstButton?.value?.href}}" attr.aria-label="{{rendering.fields?.FirstButton?.value?.text}}" class="pb-btn pb-btn-primary pb-btn--large">{{rendering.fields?.FirstButton?.value?.text}}<i class="pb-icon pb-icon-arrow-right pb-font-normal pb-text-i-24"></i></a>
      <a *ngIf="rendering.fields?.SecondButton?.value?.href" hybridHref hreflang="{{language}}" href="{{rendering.fields?.SecondButton?.value?.href}}" attr.aria-label="{{rendering.fields?.SecondButton?.value?.text}}" class="pb-btn pb-btn-transparent pb-btn--large pb-border-none">{{rendering.fields?.SecondButton?.value?.text}}</a>
  </div>
</form>
